export default function getYear(timestamp) {
  return timestamp.month() > 6 ?
    timestamp.year() :
    timestamp.year() - 1;
}
